import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-45db3bf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12,3c-4.9,0-9,4.1-9,9s4.1,9,9,9s9-4.1,9-9S17,3,12,3z M18.2,8.4h-2.6c-0.3-1.1-0.7-2.2-1.3-3.2C16,5.8,17.4,6.9,18.2,8.4z  M12,4.8c0.7,1.1,1.4,2.3,1.7,3.6h-3.4C10.7,7.1,11.3,5.9,12,4.8z M5.1,13.8c-0.2-0.5-0.3-1.2-0.3-1.8s0.1-1.3,0.3-1.8h3.1 C8,10.8,8,11.4,8,12s0.1,1.2,0.1,1.8H5.1z M5.8,15.6h2.6c0.3,1.1,0.7,2.3,1.3,3.2C8,18.2,6.6,17.1,5.8,15.6z M8.4,8.4H5.8 C6.7,6.9,8,5.8,9.7,5.2C9.1,6.2,8.8,7.3,8.4,8.4z M12,19.2c-0.7-1.1-1.3-2.3-1.7-3.6h3.4C13.4,16.9,12.7,18.1,12,19.2z M14.1,13.8 H9.9c-0.1-0.6-0.2-1.2-0.2-1.8c0-0.6,0.1-1.3,0.2-1.8h4.2c0.1,0.5,0.2,1.2,0.2,1.8C14.3,12.6,14.2,13.2,14.1,13.8L14.1,13.8z  M14.3,18.8c0.5-1,1-2.1,1.3-3.2h2.6C17.4,17,16,18.2,14.3,18.8z M16,13.8C16,13.2,16,12.6,16,12c0-0.6-0.1-1.2-0.1-1.8H19 c0.2,0.5,0.3,1.2,0.3,1.8c0,0.6-0.1,1.3-0.3,1.8H16z" })
], -1))
const _hoisted_2 = { class: "lang-menu" }
const _hoisted_3 = ["onClick"]

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import i18, { State } from '../../store/i18'
import { parseSearch, toSearch } from '@/config'
import bible from '@/store/bible/detail';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore()
const data = computed<State>(() => store.state[i18.name])
const active = ref(false)
function clickHandler() {
    active.value = !active.value
}
function switchHandler(i: number) {
    let lang = data.value.lang.list[i]
    localStorage.setItem('__lang', lang)
    if (lang == 'zh-CN') {
        bible.setVersions(store, ['hhb'])
    } else {
        bible.setVersions(store, ['niv'])
    }

    let query = parseSearch()
    query.lang = lang
    let search = toSearch(query)
    window.location.replace(location.origin + location.pathname + search + location.hash)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: "switch",
    onClick: clickHandler
  }, [
    _hoisted_1,
    _createTextVNode(" " + _toDisplayString(_unref(data).lang.name[_unref(data).lang.now]) + " ", 1),
    _withDirectives(_createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).lang.name, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          onClick: ($event: any) => (switchHandler(index))
        }, _toDisplayString(item), 9, _hoisted_3))
      }), 256))
    ], 512), [
      [_vShow, active.value]
    ])
  ]))
}
}

})